import { Box, Grid } from '@mui/material';
import CdDrawer from '../../../../components/Drawer/CdDrawer';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Loading from '../../../../components/Loading';
import Input from '../../../../components/Input/Input';
import PermissionsDataTable from '../../components/PermissionsDataTable';
import useRolesShow from './hooks/useRolesShow';

function RoleDrawerShow({ drawerAction, handleCloseDrawer, selectedItem }: any) {
    const { data, loading, clearData } = useRolesShow({
        selectedItem,
        drawerAction
    });

    return (
        <CdDrawer
            open={drawerAction === 'view'}
            onClose={() => {
                clearData();
                handleCloseDrawer();
            }}
            title={selectedItem ? `Rol ${selectedItem?.row?.nombre}` : 'Nuevo rol'}
            icon={<ArrowBackIcon />}
            onSubmit={undefined}
            goBackTxt="Cerrar"
            styles={{ width: '780px' }}
        >
            <Box height="calc(100% - 19px)">
                <Grid container spacing={1} columnSpacing={2} p={1}>
                    {loading ? (
                        <Grid item xs={12}>
                            <Loading size="medium" />
                        </Grid>
                    ) : (
                        <>
                            <Grid item xs={12} sx={{ '& h3': { mb: 0 } }}>
                                <h3>Datos del Rol</h3>
                            </Grid>
                            <Grid item xs={12}>
                                <Input
                                    label="Nombre del rol"
                                    name="nombre"
                                    fullWidth
                                    required
                                    readOnly
                                    value={data?.nombre || ''}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Input
                                    label="Descripción"
                                    name="descripcion"
                                    fullWidth
                                    required
                                    readOnly
                                    value={data?.descripcion || ''}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <PermissionsDataTable
                                    permisos={data?.permisos}
                                    selectedItem={selectedItem}
                                    drawerAction={drawerAction}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>
        </CdDrawer>
    );
}

export default RoleDrawerShow;
